import type { IconName } from '@ui/icons';

/**
 * App nav rail (Stage `VIEWS` extended to the product IA, P2 §3.2). `module` = entitlement gate, `perm` = any-of,
 * `flag` = a feature switch: with it off the entry does not exist (rail and palette), unlike a locked module.
 */
export interface NavItem { path: string; label: string; icon: IconName; module?: string; perm?: string[]; flag?: string }
/** The entries this session may see: permission (any-of) and, where one is named, the feature switch. */
export const visibleNav = (can: (perm: string[]) => boolean, flag: (key: string) => boolean) => NAV.filter((n) => (!n.perm || can(n.perm)) && (!n.flag || flag(n.flag)));
export const NAV: NavItem[] = [
  { path: '/today', label: 'Today', icon: 'gauge' },
  { path: '/leads', label: 'Leads', icon: 'inbox', module: 'leads', perm: ['leads.view'] },
  { path: '/calls', label: 'Calls', icon: 'phone', perm: ['leads.view', 'analytics.view', 'settings.manage'], flag: 'store_desk' },
  { path: '/jobs', label: 'Jobs', icon: 'wrench', perm: ['jobs.view'] },
  { path: '/dispatch', label: 'Dispatch', icon: 'map', perm: ['dispatch.view_map', 'jobs.assign'] },
  { path: '/techs', label: 'Techs', icon: 'users', perm: ['jobs.view', 'technicians.manage'] },
  { path: '/customers', label: 'Customers', icon: 'building', perm: ['customers.view'] },
  { path: '/payments', label: 'Payments', icon: 'dollar', perm: ['payments.view'] },
  { path: '/passport', label: 'Passport', icon: 'passport', module: 'passport', perm: ['customers.view'] },
  { path: '/parts', label: 'Parts', icon: 'box', module: 'parts', perm: ['parts.view'] },
  { path: '/analytics', label: 'Analytics', icon: 'chart', module: 'analytics', perm: ['analytics.view'] },
  { path: '/fleet', label: 'Fleet', icon: 'truck', module: 'fleet', perm: ['customers.view'] },
  { path: '/settings', label: 'Settings', icon: 'shield', perm: ['settings.manage', 'users.manage', 'catalog.manage', 'billing.manage'] },
];
